import React, { useEffect, useState } from "react";
import OTPConfirmation from "./otpConfirmation";
import ResetPassword from "./resetPassword";
import logoImage from "../../assests/images/logo.png";

import { useNavigate } from "react-router-dom";
import { authServices } from "../../services/authServices";
import AlertComponent from "../alert/alert";
import { Backdrop, CircularProgress } from "@mui/material";
import { isEmptyDash } from "../../constant";

function ForgotPassword() {
  let [currentIndex, setCurrentIndex] = useState(0);
  let [text, setText] = useState("");
  const [isLoading, setIsLoading] = useState(false);
  const [accessUser, setAccessUser] = useState({});
  const [alertComponent, setAlertComponent] = useState({
    open: false,
    message: "",
    type: "",
  });
  let navigate = useNavigate();

  useEffect(() => {
    setIsLoading(true);
    const search = window.location.search;
    const params = new URLSearchParams(search);
    const queryParam = params.get("code");

    if (isEmptyDash(queryParam)) {
      setCurrentIndex(0);
      setIsLoading(false);
    } else {
      authServices
        .verifyMagicLink(queryParam)
        .then(function (response) {
          openAlert(true, "success", `Please Create New Password.`);
          setAccessUser(response?.data?.data);
          // setAlertComponent({
          //   open: true,
          //   type: "success",
          //   message: `Please Create New Password.`,
          // });
          setCurrentIndex(1);
        })
        .catch(function (error) {
          openAlert(true, "error", `${error?.response?.data?.message}`);
          // setAlertComponent({
          //   open: true,
          //   type: "error",
          //   message: `${error?.response?.data?.message}`,
          // });
          setCurrentIndex(0);
        })
        .finally((param) => {
          setIsLoading(false);
        });
    }
  }, []);

  const openAlert = (open, type, message) => {
    setAlertComponent({ open, type, message });
  };

  const navigateToLogin = (url, time) => {
    setTimeout(() => {
      navigate(url);
    }, time);
  };

  const setNewPassword = (data) => {
    setIsLoading(true);
    authServices
      .createPassword(data)
      .then(function (response) {
        openAlert(
          true,
          "success",
          `Your password has been changed successfully.`
        );
        navigateToLogin("/auth/login", 2000);
      })
      .catch(function (error) {
        openAlert(true, "error", `${error?.response?.data?.message}`);
        navigateToLogin("/auth/login", 2000);
        setCurrentIndex(0);
      })
      .finally((param) => {
        setIsLoading(false);
      });
  };

  const handleClose = (event, reason) => {
    if (reason === "clickaway") {
      return;
    }
    setAlertComponent({ ...alertComponent, open: false });
  };

  const submitUserId = () => {
    setIsLoading(true);
    authServices
      .resetPassword({
        email: text,
      })
      .then(function (response) {
        openAlert(
          true,
          "success",
          `Magic link sent successfully on your registered E-mail id.`
        );
        navigateToLogin("/auth/login", 2000);

        // setAlertComponent({
        //   open: true,
        //   type: "success",
        //   message: `Magic link sent successfully on your registered E-mail id.`,
        // });
        // let path = `/auth/login`;
        // navigate(path);
        // if (response?.data?.success == true) {
        //   sessionStorage.setItem("user", JSON.stringify(response?.data?.data));
        //   window.location.href= '/admin/dashboard';
        //   // let path = `/admin/dashboard`;
        //   // navigate(path);
        // }
      })
      .catch(function (error) {
        setAlertComponent({
          open: true,
          type: "error",
          message: `${error?.response?.data?.message}`,
        });
      })
      .finally((param) => {
        setIsLoading(false);
      });
    // setCurrentIndex(1);
  };

  const submitOtp = () => {
    setCurrentIndex(2);
  };

  const submitResetPassword = () => {
    navigate("/auth/login");
  };

  const onTextChange = (e) => {
    setText(e.target.value);
  };
  const onKeyPressHandler = (e) => {
    e.persist();
    if (e.key === "Enter") {
      submitUserId();
    }
  };

  return (
    <div class="login-form">
      {currentIndex == 0 && (
        <div>
          <div class="text-center">
            <div className="logo_login_react_vendors">
              <img src={logoImage} alt="" height="51" />
            </div>
            <h3 class="title">Forgot Password</h3>
            <p>
              Enter your email id for verification process we will send
              verification link to your email.
            </p>
          </div>
          <div>
            <div class="mb-4 position-relative">
              <label class="mb-1 text-dark">Email</label>
              <input
                type="email"
                class="form-control form-h"
                placeholder="Enter your email id"
                onChange={onTextChange}
                value={text}
                onKeyPress={onKeyPressHandler}
              />

              <span class="user">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="20"
                  height="20"
                  fill="currentColor"
                  class="bi bi-person"
                  viewBox="0 0 16 16"
                >
                  <path d="M8 8a3 3 0 1 0 0-6 3 3 0 0 0 0 6m2-3a2 2 0 1 1-4 0 2 2 0 0 1 4 0m4 8c0 1-1 1-1 1H3s-1 0-1-1 1-4 6-4 6 3 6 4m-1-.004c-.001-.246-.154-.986-.832-1.664C11.516 10.68 10.289 10 8 10s-3.516.68-4.168 1.332c-.678.678-.83 1.418-.832 1.664z" />
                </svg>
              </span>
            </div>
            <div>
              <div class="text-center mb-4">
                <button
                  onClick={submitUserId}
                  class="btn btn-primary btn-log reset-btn"
                >
                  Reset Password
                </button>
              </div>
            </div>
          </div>
        </div>
      )}

      {/* {(currentIndex == 1) && <OTPConfirmation submitOtp={submitOtp} />} */}

      {currentIndex == 1 && (
        <ResetPassword
          submitResetPassword={submitResetPassword}
          accessUser={accessUser}
          openAlert={openAlert}
          setNewPassword={setNewPassword}
        />
      )}

      <AlertComponent
        alertComponent={alertComponent}
        handleClose={handleClose}
      />
      <Backdrop
        sx={{ color: "#fff", zIndex: (theme) => theme.zIndex.drawer + 1 }}
        open={isLoading}
      >
        <CircularProgress color="inherit" />
      </Backdrop>
    </div>
  );
}

export default ForgotPassword;
